import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'gift.giftOverlay.chooseOptions',
    defaultMessage: 'To buy a gift card, choose from the options below.',
    description: 'Title of a dialog showing authentication choices',
  },
  continueCta: {
    id: 'gift.continueAsGuest.continueButton',
    defaultMessage: 'Continue as guest',
    description: 'Button to continue purchasing as an unregistered user',
  },
});
